<template>
    <div
        class="product-title text-center text-md-start"
        :class="{
            'title-compact': compact
        }"
    >
        <div
            class="d-flex justify-center justify-md-start"
        >
            <component
                v-if="!isLogoLoadError && product.logo"
                :is="tagHeader"
                class="line-height-0 pa-0 ma-0"
            >
                <Logo
                    :logo="product.logo"
                    :font-size-px="fontSizePx"
                    @on-error="onLogoLoadErr"
                ></Logo>
            </component>
            <component
                v-else
                :is="tagHeader"
                ref="elProductTitle"
                class="line-height-normal flex-grow-0 pa-0 ma-0"
                :style="{
                    fontSize: `${fontSizePx}px`
                }"
                :class="{
                    'text-uppercase': !naturalCase,
                    'font-weight-medium': noBold
                }"
            >
                {{ product.name }}
            </component>
        </div>
        <h4
            v-if="product.tagline"
            v-html="product.tagline"
            class="font-size-6 mt-1 mt-md-2 mb-0"
            :class="{
                'font-weight-regular': noBold,
                'font-weight-medium': !noBold
            }"
        ></h4>
    </div>
</template>

<script lang="ts" setup>
    import type { Product } from '~/types';
    import Logo from '~/components/common/Logo/Logo.vue';

    const props = withDefaults(
        defineProps<{
            product: Product;
            compact?: boolean;
            fontSizePx?: number;
            pageTitle?: boolean;
            noBold?: boolean;
            naturalCase?: boolean;
        }>(),
        {
            compact: false,
            fontSizePx: 32,
            naturalCase: false
        }
    );

    const tagHeader = computed(() => !!props.pageTitle ? 'h1' : 'h3');
    const isLogoLoadError = ref<boolean>(false);

    function onLogoLoadErr(e: Event): void {
        isLogoLoadError.value = true;
    }
</script>

<style lang="scss">
.product-title {
    h3 {
        font-size: 2rem;
        line-height: 1;
    }

    h4 {
        font-size: 1.4rem;
        margin-top: -0.2rem;
    }

    &.title-compact {
        h3 {
            font-size: 1.6rem;
        }

        h4 {
            font-size: 1.2rem;
            margin-top: 0;
        }
    }
}
</style>
